export const SidebarAnimation = {
  initial: {
    x: '-100%',
  },
  animate: {
    x: 0,
    transition: { ease: 'easeOut', duration: 0.45 },
  },
  exit: {
    x: '-100%',
    transition: { ease: 'easeOut', duration: 0.3 },
  },
};
